import tagBreadcrumbs from '../../../features/analytics/breadcrumbs';

/**
 * Generates breadcrumbs for the given categories
 *
 * @param {Array.<Category>} categories categories list
 * @returns {import("primevue/menuitem").MenuItem[]}
 */
export const generateBreadcrumbs = (categories) => {
  /**
   * @type {import("primevue/menuitem").MenuItem[]}
   */
  const list = categories.map(({ name: label, url, type }, index) => ({
    url,
    label,
    command: () => {
      const data = {
        length: categories.length,
        category: type,
        name: label.toLowerCase(),
        position: index + 1,
      };
      tagBreadcrumbs(data);
    },
  }));

  return list;
};

/**
 * Generates breadcrumbs for the given categories
 *
 * @param {Array.<Category>} categories categories list
 */
export const getHomeCategoryBreadcrumb = (categories = []) => categories[categories.length - 1];

/**
 * Prepare link to offer modifications
 *
 * @example
 * const categoryLink = "/shop/mens-clothing/all-mens-clothing/mens-jackets-coats?id=3763&edge=hybrid"
 * const result = getCategoryUrlWithPromoPlug(categoryLink)
 * console.log(result) // "/shop/mens-clothing/all-mens-clothing/mens-jackets-coats/Special_offers/[PROMO_PLUG]?id=3763&edge=hybrid"
 *
 * @param {Category['url']} categoryLink
 * @returns {string}
 */
export const getCategoryUrlWithPromoPlug = (categoryLink = '') => {
  const [categoryPath, query] = categoryLink.split('?');
  return `${categoryPath}/[PROMO_PLUG]?${query}`;
};

export default {
  generateBreadcrumbs,
  getHomeCategoryBreadcrumb,
  getCategoryUrlWithPromoPlug,
};
